import { Link } from "react-router-dom";
import { CONTACT, NAV, DIVISIONS, IDENTIFIERS, SOCIAL } from "../../data/content";

export const Footer = () => (
    <footer className="border-t border-thg-border bg-[#0a0a0a]" data-testid="site-footer">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
            <div className="md:col-span-5">
                <div className="flex items-center gap-3">
                    <img
                        src="/assets/thg-shield-sm.png"
                        alt="Titan Haven Group LLC shield"
                        className="h-10 w-auto"
                    />
                    <span className="font-display text-lg font-semibold tracking-wide text-white">
                        TITAN HAVEN GROUP <span className="text-thg-secondary text-[0.7em] tracking-[0.2em]">LLC</span>
                    </span>
                </div>
                <p className="mt-6 text-sm leading-relaxed text-thg-secondary max-w-sm">
                    Titan Haven Group builds and operates software, emerging technology,
                    consumer businesses, digital assets, and media/IP.
                </p>
                <p className="mt-4 text-xs leading-relaxed text-thg-tertiary">
                    {IDENTIFIERS.legalName} is a {IDENTIFIERS.structure}.
                </p>
                <p className="mt-4 text-xs tracking-[0.2em] uppercase text-thg-tertiary">
                    Observe &rarr; Question &rarr; Synthesize &rarr; Act
                </p>
            </div>
            <nav className="md:col-span-3" aria-label="Footer">
                <h3 className="text-xs tracking-[0.2em] uppercase font-bold text-thg-tertiary">Company</h3>
                <ul className="mt-5 space-y-3">
                    {NAV.map((item) => (
                        <li key={item.to}>
                            <Link
                                to={item.to}
                                data-testid={`footer-${item.testId}`}
                                className="text-sm text-thg-secondary hover:text-white transition-colors duration-300"
                            >
                                {item.label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </nav>
            <div className="md:col-span-4">
                <h3 className="text-xs tracking-[0.2em] uppercase font-bold text-thg-tertiary">Contact</h3>
                <ul className="mt-5 space-y-3 text-sm text-thg-secondary">
                    <li>
                        <a
                            href={`mailto:${CONTACT.email}`}
                            data-testid="footer-email"
                            className="hover:text-white transition-colors duration-300"
                        >
                            {CONTACT.email}
                        </a>
                    </li>
                    <li>
                        <a
                            href={CONTACT.phoneHref}
                            data-testid="footer-phone"
                            className="hover:text-white transition-colors duration-300"
                        >
                            {CONTACT.phone}
                        </a>
                    </li>
                    <li className="text-thg-tertiary">Wyoming LLC &middot; East Coast Operations</li>
                </ul>
                <div className="mt-8 flex flex-wrap gap-x-4 gap-y-2">
                    {DIVISIONS.slice(0, 3).map((d) =>
                        d.external ? (
                            <a
                                key={d.name}
                                href={d.to}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-xs text-thg-tertiary hover:text-white transition-colors duration-300"
                            >
                                {d.name}
                            </a>
                        ) : (
                            <Link
                                key={d.name}
                                to={d.to}
                                className="text-xs text-thg-tertiary hover:text-white transition-colors duration-300"
                            >
                                {d.name}
                            </Link>
                        ),
                    )}
                </div>
                <div className="mt-6 flex flex-col gap-2" data-testid="footer-channels">
                    {SOCIAL.map((s) => (
                        <a
                            key={s.href}
                            href={s.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-xs text-thg-tertiary hover:text-white transition-colors duration-300"
                            aria-label={`${s.label} — opens in a new tab`}
                        >
                            {s.label}
                        </a>
                    ))}
                </div>
            </div>
        </div>
        <div className="border-t border-thg-border">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-thg-tertiary">
                <span>&copy; {new Date().getFullYear()} Titan Haven Group LLC. All rights reserved.</span>
                <span>We build what the problem requires.</span>
            </div>
        </div>
    </footer>
);
